export default function appTell(phone) {
    try {
        window.CSNativeObject.nativeContactWithPhone({ phone: phone });
    }
    catch (e) { }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/app/appTell.js
// module id = null
// module chunks = 